import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// Fetch every photo-layout override once, exposed as a { [section]: string[] } map.
// Consumers do: `overrides['story.beats.3'] ?? DEFAULT_IMGS[3]`.
export function usePhotoLayouts() {
  const { token } = useAuth();
  const [layouts, setLayouts] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/photo-layouts");
        if (cancelled) return;
        const map = {};
        for (const l of data.layouts || []) map[l.section] = l.photos || [];
        setLayouts(map);
      } catch (_e) {
        /* silent */
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return { layouts, loaded };
}

// Utility: pick override if present, else default
export function pickPhotos(layouts, section, defaultPhotos) {
  return section in layouts ? layouts[section] : defaultPhotos;
}
